import { isEmpty, isEqual, isFunction, localUser } from "@util/utils";
import React, { useEffect, useMemo, useState } from "react";
import { MenuItem, SelectField } from "@curves/ui-base";

const EmployeeSelect = React.forwardRef((props, ref) => {
	const { label = "擔當", options = [], defaultValue: defaultValueProps = "", onChange: onChangeProps, ...restProps } = props;
	const [internalValue, setInternalValue] = useState("");
	const handleChange = (_, { props }) => {
		setInternalValue(props.value);
		isFunction(onChangeProps) && onChangeProps(props.value);
	};

	const itemMemo = useMemo(
		() => {
			return (
				Array.isArray(options) &&
				options
					.filter(item => item || !item.disabled)
					.map(item => (
						<MenuItem key={item.value} value={item.value}>
							{item.text}
						</MenuItem>
					))
			);
		},
		// eslint-disable-next-line
		[options]
	);

	useEffect(
		() => {
			if (isEmpty(options)) return;
			let eID = defaultValueProps;
			const employee = localUser.get("employee") || {};
			const { employeeID = "" } = employee;
			if (defaultValueProps || isEmpty(employee)) {
				eID = defaultValueProps;
			} else {
				eID = employeeID;
			}
			// 假如來源值的值不存在option裡
			if (!options.some(({ value }) => isEqual(value, eID))) eID = "";
			setInternalValue(eID);
		},
		// eslint-disable-next-line
		[defaultValueProps, JSON.stringify(options)]
	);

	return (
		<React.Fragment>
			<SelectField ref={ref} defaultValue={defaultValueProps} value={internalValue} label={label} onChange={handleChange} displayEmpty {...restProps}>
				<MenuItem disabled value="">
					<em>請選擇</em>
				</MenuItem>
				{itemMemo}
			</SelectField>
		</React.Fragment>
	);
});

export default EmployeeSelect;
